import { getDateMoment, getDestinationTimeZone } from "../../../helpers/dateHelper";
import { SortOrder } from "../../../hooks/useTableSort";
import { BookingStatus } from "../../../models/booking";

export type BookingsFilters = {
    dateFrom: Date | null;
    dateTo: Date | null;
    shipName: string;
    docks: string[];
    bookingStatuses: BookingStatus[];
    rowsPerPage: number;
    page: number;
    order: SortOrder;
    finalized: boolean | null;
};

export function buildBookingsSearchPayload(filters: BookingsFilters, timeZone?: string) {
    return {
        docks: filters.docks,
        offset: filters.page * filters.rowsPerPage,
        limit: filters.rowsPerPage,
        textSearch: filters.shipName,
        order: filters.order,
        columns: {},
        filter: buildBookingsSearchPayloadFilters(filters, getDestinationTimeZone(timeZone)),
    };
}

function buildBookingsSearchPayloadFilters(filters: BookingsFilters, timeZone: string) {
    const { bookingStatuses, dateFrom, dateTo, finalized } = filters;

    const filterArray: object[] = [];

    if (bookingStatuses.length > 0) {
        const bsFilterArray: object[] = [];
        bookingStatuses.forEach(st => bsFilterArray.push({ status: st.toString() }));
        filterArray.push({ $or: bsFilterArray });
    }

    if (dateFrom && !dateTo) {
        const startDate = getDateMoment(dateFrom, { timeZone }).startOf("day");
        const endDate = getDateMoment(dateFrom, { timeZone }).endOf("day");
        filterArray.push(
            { arrivalTime: { $gte: startDate.valueOf() } },
            { arrivalTime: { $lte: endDate.valueOf() } },
        );
    }

    if (dateTo && !dateFrom) {
        const startDate = getDateMoment(dateTo, { timeZone }).startOf("day");
        const endDate = getDateMoment(dateTo, { timeZone }).endOf("day");
        filterArray.push(
            { departureTime: { $gte: startDate.valueOf() } },
            { departureTime: { $lte: endDate.valueOf() } },
        );
    }

    if (dateTo && dateFrom) {
        const startDate = getDateMoment(dateFrom, { timeZone }).startOf("day");
        const endDate = getDateMoment(dateTo, { timeZone }).endOf("day");
        filterArray.push(
            { arrivalTime: { $gte: startDate.valueOf() } },
            { departureTime: { $lte: endDate.valueOf() } },
        );
    }

    if (finalized === true || finalized === false) {
        filterArray.push({ finalized: finalized });
    }

    return { $and: filterArray };
}
